import { NbNativeDateService } from "@nebular/theme";

export class PtBrDateService extends NbNativeDateService {
  parse(date: string): Date {
    const [day, month, year] = date.split('/').map(Number);

    if (!day || !month || !year) {
      return super.parse(date, 'dd/MM/yyyy');
    }

    return new Date(year, month - 1, day);
  }
}